import StringUtils from '../text/StringUtils';
export default class ReflectionUtils {
    static nameOf(expr) {
        var _a;
        return (_a = StringUtils.matchFirst(expr.toString(), '[a-z_$][a-z0-9_$]*\\.([a-z_$][a-z0-9_$]*)', { caseSensitive: false })) === null || _a === void 0 ? void 0 : _a[1];
    }
}
//# sourceMappingURL=ReflectionUtils.js.map